import forEach from 'lodash.foreach'
import axios from 'axios'


export const seatsio = {
  namespaced: true,
  state: {
    config: {},
    purchase: {},
    data: {},
    tickets: [],
    minTickets: {},
    available: {},
    pair: {},
    formattedSeats: {},
    total: 0,
    taxes: 0
  },
  mutations: {
    setConfig(state, config) {
      state.config = config
    },
    setPurchase(state, purchase) {
      state.purchase = purchase
    },
    setTickets(state, tickets) {
      state.tickets = tickets
    },
    setMinTickets(state, minTickets) {
      state.minTickets = minTickets
    },
    setAvailable(state, available) {
      state.available = available
    },
    setPair(state, pair) {
      state.pair = pair
    },
    setData(state, data) {
      state.data = data
    },
    cleanCategoryLabel(state) {
      state.data.tickets.forEach(item => {
        delete item.category_label
      })
    },
    fillTicket(state, { ticket, name, id_card, index }) {
      var exists = 0
      state.data.tickets.forEach(item => {
        if (item.external_id === ticket.external_id && index === exists) {
          item.name = name || item.name
          item.id_card = id_card || item.name
        }
        exists++
      })
    },
    formatSeats(state) {
      var seatObject = {}
      state.formattedSeats = {
        categories: []
      }
      state.data.tickets.forEach(seat => {
        state.tickets.ticket_types.forEach(ticket => {
          if (parseInt(seat.category) === parseInt(ticket.external_id)) {
            seatObject.personal = ticket.personal
            seatObject.personal_id = ticket.personal_id
            seatObject.price = ticket.price
            seatObject.customer_commission = ticket.customer_commission
            seatObject.currency = ticket.currency
          }
        })
        var exists = false
        state.formattedSeats.categories.forEach(item => {
          if (item.id === seat.category) {
            exists = true
            item.quantity = item.quantity + 1
            item.tickets.push(seat)
          }
        })
        if (!exists) {
          state.formattedSeats.categories.push({
            id: seat.category,
            category_label: seat.category_label,
            price: seatObject.price,
            personal: seatObject.personal,
            personal_id: seat.personal_id,
            customer_commission: seatObject.customer_commission,
            tickets: [seat],
            currency: seatObject.currency,
            quantity: 1
          })
        }
      })
    },
    setTaxesAndTotal(state) {
      state.taxes = 0
      state.total = 0
      forEach(state.formattedSeats.categories, item => {
        state.taxes = state.taxes + item.quantity * item.customer_commission
        state.total = state.total + item.price * item.quantity
      })
      state.total = state.total + state.taxes
    }
  },
  actions: {
    async config({ commit }, payload) {
      await axios
        .get(`/seatsio/${payload.ticket_dist}/widget_info/`, {
          params: { places: payload.places }
        })
        .then(res => {
          console.log('res then', res)
          commit('setConfig', res.data)
        })
        .catch(res => {
          console.log('res catch', res);
          if (typeof window !== 'undefined') {
            if (typeof CustomEvent === 'function') {
              var event = new CustomEvent('showError', {
                detail: {
                  textI18N: 'error.title',
                  error: res
                }
              })
              window.dispatchEvent(event)
            }
          }
        })
    },
    async tickets({ commit }, payload) {
      await axios
        .get('/ticket-types/', {
          params: payload
        })
        .then(res => {
          commit('setTickets', res.data)
          const minTickets = {};
          const available = {};
          const pair = {};
          res.data.ticket_types.forEach(item => {
            minTickets[item.external_id] = item.min_tickets
            available[item.external_id] = item.available
            pair[item.external_id] = item.pair
          });
          commit('setMinTickets', minTickets)
          commit('setAvailable', available)
          commit('setPair', pair)
        })
        .catch(res => {
          if (typeof window !== 'undefined') {
            if (typeof CustomEvent === 'function') {
              var event = new CustomEvent('showError', {
                detail: {
                  textI18N: 'error.title',
                  error: res
                }
              })
              window.dispatchEvent(event)
            }
          }
        })
    },
    async purchase({ commit }, payload) {
      await axios
        .post('/seatsio/purchases/', payload)
        .then(res => {
          commit('setTickets', res.data)
        })
        .catch(res => {
          if (typeof window !== 'undefined') {
            if (typeof CustomEvent === 'function') {
              var event = new CustomEvent('showError', {
                detail: {
                  textI18N: 'error.title',
                  error: res
                }
              })
              window.dispatchEvent(event)
            }
          }
        })
    },
    setData({ commit }, payload) {
      commit('setData', payload)
    },
    cleanCategoryLabel({ commit }, payload) {
      commit('cleanCategoryLabel', payload)
    },
    fill({ commit }, payload) {
      commit('fillTicket', payload)
    },
    formatSeats({ commit }) {
      commit('formatSeats')
    },
    setTaxesAndTotal({ commit }) {
      commit('setTaxesAndTotal')
    }
  }
}
